export default {
  types: 'Project types',
  type: 'Project type',
  verbose_type: 'a project type',
  messages: {
    type_not_found: 'Project type not found',
  },
};
